<div class="order-stepper matRipple file-upload">
  <div class="dropzone">
    <div>
      <!-- <input type="text" id="fileDropRef" type="file" #fileDropRef /> -->
      <button class="upload-btn" (click)="sendResultBack()" mat-flat-button>
        <span style="font-size: 14px; cursor: pointer" *ngIf="!isFileUploaded">
          آپلود فایل
        </span>
        <span style="font-size: 14px; cursor: pointer" *ngIf="isFileUploaded">
          ویرایش فایل
        </span>
      </button>
    </div>
  </div>
</div>
